const RoamCart = {
    updateQuantity(line, qty) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({quantity: qty, line: line,})
        })
            .then(response => response.json())
            .then(() => window.dispatchEvent(new Event('cart-updated')))
            .catch(error => console.error('Error:', error));
    }
}